import React from "react";
import { Flex, Box } from "grid-styled";
import AddressCard from "./AddressCard";
import ContactCard from "./job/ContactCard";
import SalespersonCard from "./job/SalespersonCard";
import DraftsmanCard from "./job/DraftsmanCard";
import ProjectInfoCard from "./job/ProjectInfoCard";
import NgcCard from "./job/NgcCard";
import { gql } from "apollo-boost";
import { graphql, compose } from "react-apollo";
import CenteredLoader from "./CenteredLoader";
import withCurrentUser from "../hocs/withCurrentUser";

class JobDetails extends React.Component {
  update = input => {
    return this.props.updateJob({
      id: this.props.job.id,
      input
    });
  };

  render() {
    const { loading, job, userData } = this.props;
    if (loading && !job) return <CenteredLoader />;
    const isAdmin = userData && userData.isAdminUser;
    return (
      <Flex pt={3} wrap>
        <Box w={[1, 1 / 2]} pr={2}>
          <AddressCard
            cardTitle="Job Site"
            address={job.jobSite}
            onSave={values => this.update({ jobSite: values })}
          />
          <SalespersonCard
            salesperson={job.salesperson}
            franchiseId={job.franchise ? job.franchise.id : null}
            onSave={this.update}
            mt={3}
          />
          <DraftsmanCard
            draftsman={job.draftsman}
            onSave={this.update}
            canEdit={isAdmin}
            mt={3}
          />
        </Box>
        <Box w={[1, 1 / 2]} pl={2}>
          <ContactCard
            contact={job.contact}
            sendToChatmeter={job.sendToChatmeter}
            onSave={this.update}
          />
          {isAdmin && <ProjectInfoCard job={job} onSave={this.update} mt={3} />}
          {isAdmin && <NgcCard job={job} onSave={this.update} mt={3} />}
        </Box>
      </Flex>
    );
  }
}

const fragments = {
  job: gql`
    fragment JobDetailJob on Job {
      id
      contractType
      contractNumber
      completionDate
      finalPaymentDate
      structureType
      ngcPackageSent
      ngcPackageSentOn
      ngcPackageSentVia
      ngcPackageEmailedTo
      ngcPackageEmailStatus
      ngcPackageEmailOpened
      ngcPackageEmailOpenedAt
      sendToChatmeter
      contact {
        id
        firstName
        lastName
        phone
        email
        otherFirstName
        otherLastName
        address {
          id
          streetAddress
          aptNumber
          city
          state
          zipCode
          country
        }
      }
      jobSite {
        id
        streetAddress
        aptNumber
        city
        state
        zipCode
        country
      }
      franchise {
        id
        name
        assignedInHouseTty
      }
      salesperson {
        id
        name
        email
        phone
      }
      draftsman {
        id
        name
        email
        phone
      }
    }
  `
};

const JOB_DETAIL_QUERY = gql`
  query JobDetailQuery($id: ID!) {
    job(id: $id) {
      ...JobDetailJob
    }
  }
  ${fragments.job}
`;

const UPDATE_JOB_MUTATION = gql`
  mutation UpdateJob($id: ID!, $input: JobInput!) {
    updateJob(id: $id, input: $input) {
      ...JobDetailJob
    }
  }
  ${fragments.job}
`;

const enhance = compose(
  withCurrentUser(),
  graphql(JOB_DETAIL_QUERY, {
    options: ({ match: { params: { jobId } } }) => ({
      variables: { id: jobId },
      pollInterval: 30 * 1000
    }),
    props: ({ data: { loading, error, job } }) => ({
      loading,
      error,
      job
    })
  }),
  graphql(UPDATE_JOB_MUTATION, {
    props: ({ mutate }) => ({
      updateJob: ({ id, input }) => {
        return mutate({
          variables: { id, input }
        });
      }
    })
  })
);

export default enhance(JobDetails);



// WEBPACK FOOTER //
// ./src/components/JobDetails.js